<script lang="ts">
	import { createEventDispatcher } from 'svelte'

	import { setAccount } from '$lib/stores/account/manager'
	const dispatch = createEventDispatcher()
	// const stateContext: any = getContext('state')

	export let pageSize: any
	export let hideLabelOnMobile = true
	// export let disabled = false

	function onPageSizeChange(event: any) {
		let newPageSize = Number(event.currentTarget.value)
		setAccount({ default_results_per_page: newPageSize })
		dispatch('pageSizeChange', { newPageSize: newPageSize })
	}
</script>

<div class="whitespace-nowrap max-w-min inline-flex align-middle mb-2">
	<label
		for="pageSize"
		class="py-1 text-base text-gray-600"
		class:pageSize-label-hideOnMobile={hideLabelOnMobile}
	>
		Results per page :&nbsp;
	</label>
	<select
		id="pageSize"
		data-test-id="rows_count_selector"
		name="pageSize"
		value={pageSize.toString()}
		class="rounded-md bg-gray-100 border-gray-300 py-1 pl-2 pr-2 inline-block
                   text-base text-gray-600 align-middle
                 focus:border-indigo-500 focus:outline-none focus:ring-indigo-500"
		on:change={(e) => onPageSizeChange(e)}
	>
		<!-- <option value="3">3</option> -->
		<option value="10">10</option>
		<option value="25">25</option>
		<option value="50">50</option>
		<option value="100">100</option>
	</select>
</div>

<style lang="postcss">
	/* @media screen and (max-width: 432px) { */
	@media screen and (max-width: 639px) {
		.pageSize-label-hideOnMobile {
			display: none;
		}
	}
</style>
